<template>
	<div class="content-box">
		<el-tabs v-model="activeName" v-if="hasGetTableDataModel">
			<el-tab-pane label="新建订单" name="build">
				<div class="content-box">
					<edit-order v-if="activeName=='build'"></edit-order>
				</div>
			</el-tab-pane>
			<el-tab-pane label="待派单" name="check">
				<due-order v-if="activeName=='check'"></due-order>
			</el-tab-pane>
			<el-tab-pane label="待出库" name="send">
				<wait-send v-if="activeName=='send'"></wait-send>
			</el-tab-pane>
			<el-tab-pane label="出库记录" name="his">
				<his v-if="activeName=='his'" :type="[20]"></his>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import Inventory from "@/mixinsApp/Inventory.js";
import DueOrder from "@/views/Order/subs/DueOrder.vue";
import WaitSend from "@/views/Inventory/subs/WaitSend.vue";
import TabPage from "@/mixins/TabPage.js";
import EditOrder from "@/views/Order/subs/EditOrder.vue";

export default {
	mixins: [Inventory, TabPage],
	components: {
		EditOrder,
		DueOrder,
		WaitSend,
	},
	data() {
		return {
			activeName: "check"
		};
	},
	computed: {},
	methods: {}
};
</script>